export default __webpack_public_path__ + "static/media/Opprettelse av Entreprenørskapsfondet ved UIT.719cf176.pdf";